module.exports = __webpack_public_path__ + "static/media/11.b16a1e84.svg";